// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Ia5yz","form-footer":"styles_form-footer__TIzW7","fullView":"styles_fullView__RC5LM","shimmer":"styles_shimmer__Odiec"};